var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.147 1.258a3.6 3.6 0 012.285 6.38c.877.3 1.686.773 2.365 1.398 1.122 1.034 1.77 2.738 1.918 4.19.071.707-.509 1.23-1.139 1.231H2.719c-.63 0-1.21-.524-1.139-1.23.147-1.453.796-3.157 1.918-4.19a6.678 6.678 0 012.363-1.4 3.6 3.6 0 012.286-6.38zm0 7.199c-1.447 0-2.826.53-3.836 1.461-.825.76-1.382 2.107-1.526 3.34H13.51c-.145-1.233-.702-2.58-1.527-3.34-1.01-.93-2.389-1.461-3.836-1.461zm0-6a2.4 2.4 0 100 4.801 2.4 2.4 0 000-4.801z"
  })));
}
export default SvgIconUser;